module.exports = __webpack_public_path__ + "img/preview.570c3b83.png";